import React from 'react';
import AuthService, { privileges, functionalities, features } from '@/shared/services/AuthService';

import messages from './dashboardMessages';
import MonthlyRevenueDashboard from './dashboards/MonthlyRevenueDashboard';
import TopCustomerRevenueDashboard from './dashboards/TopCustomerRevenueDashboard';
import ComplianceDashboard from './dashboards/ComplianceDashboard';
import PeppolDashboard from './dashboards/PeppolDashboard';
import RecentRelationsDashboard from './dashboards/RecentRelationsDashboard';
import SearchRelationDashboard from './dashboards/SearchRelationDashboard';
import TodoListDashboard from './dashboards/TodoListDashboard';
import MyRegistrationsDashboard from './dashboards/MyRegistrationsDashboard';
import MyTaskKpiDashboard from './dashboards/MyTaskKpiDashboard';
import AbsenceDashboard from './dashboards/AbsenceDashboard';

const canReadFinalInvoice = () =>
  AuthService.hasPermission({
    functionality: functionalities.InvoiceFinal,
    privilege: privileges.read,
  });

const imgStyle = { height: '100%', width: '100%' };
/* lg: 12, md: 6, sm: 4, xs: 2 */
const definitions = {
  SearchRelation: {
    minW: 1,
    minH: 1,
    maxW: 6,
    maxH: 1,
    w: 2,
    h: 1,
    x: 0,
    y: 0,
    title: messages.SearchRelation,
    render: params => <SearchRelationDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.Relation,
        privilege: privileges.Read,
      }),
  },
  RecentRelations: {
    title: messages.RecentRelations,
    render: params => <RecentRelationsDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.Relation,
        privilege: privileges.Read,
      }),
  },
  RevenuePerMonth: {
    title: messages.RevenuePerMonth,
    render: params => <MonthlyRevenueDashboard {...params} />,
    enabled: canReadFinalInvoice,
  },

  MostValuableCustomers: {
    title: messages.MostValuableCustomers,
    render: params => <TopCustomerRevenueDashboard {...params} />,
    enabled: canReadFinalInvoice,
  },
  Compliancy: {
    title: messages.Compliancy,
    render: params => <ComplianceDashboard {...params} />,
    enabled: () =>
      AuthService.hasFeature(features.Compliancy) &&
      AuthService.hasPermission({
        functionality: functionalities.Relation,
        privilege: privileges.Read,
      }),
  },
  PeppolOnboarding: {
    title: messages.PeppolOnboarding,
    render: params => <PeppolDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.Relation,
        privilege: privileges.Read,
      }),
    minH: 3,
    minW: 5,
    w: 5,
    h: 3,
  },
  MyTodos: {
    title: messages.MyTodos,
    render: params => <TodoListDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.Todo,
        privilege: privileges.Read,
      }),
  },
  MyRegistrations: {
    title: messages.MyRegistrations,
    render: params => <MyRegistrationsDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.RegistrationOwn,
        privilege: privileges.Read,
      }),
    minH: 2,
  },
  MyTasksKpis: {
    title: messages.MyTasksKpis,
    render: params => <MyTaskKpiDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.PlannedTask,
        privilege: privileges.Read,
      }),
    minH: 2,
  },
  Absences: {
    title: messages.AbsenceCounters,
    render: params => <AbsenceDashboard {...params} />,
    enabled: () =>
      AuthService.hasPermission({
        functionality: functionalities.RegistrationOwn,
        privilege: privileges.Read,
      }),
    minH: 2,
  },
  // TileExample1: {
  //   w: 1,
  //   h: 1,
  //   maxW: 1,
  //   maxH: 1,
  //   isResizable: false,
  //   render: () => (
  //     <div className="height100pct">
  //       <img src="https://static.adminpulse.eu/public/tmp/tile1.png" style={imgStyle} />
  //     </div>
  //   ),
  // },
  // TileExample2: {
  //   w: 1,
  //   h: 1,
  //   maxW: 1,
  //   maxH: 1,
  //   isResizable: false,
  //   render: () => (
  //     <div className="height100pct">
  //       <img src="https://static.adminpulse.eu/public/tmp/tile2.png" style={imgStyle} />
  //     </div>
  //   ),
  // },
};
export default definitions;
